export var utils;
(function (utils) {
    function escape(str) {
        return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    utils.escape = escape;
})(utils || (utils = {}));
